/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React from 'react'
// import useStyles from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
import { RiErrorWarningLine } from "react-icons/ri";

export default function RequiredMsg(props) {
  const {useStyle} = ThemeControls;
    let {field_label,field_btn_label,field_btn_label_2} = props
    
    const classes = useStyle();

    return ( 
        <div className={classes.inputroot}>
        <div className={classes.RequiredMsg}>
          <span>
            <RiErrorWarningLine />
          </span>
          <div className={classes.txtp}>
            <p>{field_label}</p>
            <div className={classes.RequiredMsgbtn}>
              <div>MSISDN</div>
              <div>Email</div>
            </div>
          </div>
        </div>
      </div>   
    );  
}
